import { createImageElement } from "converterUtils";

class ConverterProduct extends HTMLLabelElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.imgSrc = this.dataset.imgSrc;
    this.modalTrigger = this.querySelector('gtc-trigger');

    if (!this.modalTrigger || !this.imgSrc) {
      return;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    this.modalTrigger.addEventListener('click', () => {
      const modal = document.getElementById('modal-image');
      const imgElement = createImageElement(this.imgSrc);
      modal.replaceChildren(imgElement);
    });
  } 
}

if (!customElements.get('converter-product')) {
  customElements.define('converter-product', ConverterProduct, { extends: "label" });
}